import { FoamingObj } from '@usimweb/core/models';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface Validation {
  isValid: boolean;
  index: number;
}

export interface OpenMold {
  start: number;
  duration: number;
  moldClosingTimeDuration: number;
  moldClosingTime: number;
  nozzleDiameter: number;
  nozzleVelocity: number;
  offset: number;
  isClosingSetup: boolean;
  moldClosing?: {};
}

export interface MoldClosing {
  openingVector: cee.Vec3;
  part: string;
}

export interface Path {
  position: { x: number; y: number; z: number };
  orientation: { x: number; y: number; z: number };
  timestep: number;
}

@Injectable({
  providedIn: 'root',
})
export class FoamingValidation {
  constructor(private snackBar: MatSnackBar) {}

  public checkValidation(material: string, usimdata: string, foaming: FoamingObj, isOpenMold: boolean): Validation {
    let stepOrder: number = 0;

    if (isOpenMold) {
      stepOrder = 1;
      const openMold = foaming.openMold as OpenMold;
      const moldClosing = openMold.moldClosing as MoldClosing;
      const path = foaming.openMold as Path[];

      if (openMold.start === undefined) {
        this.snackBar.open('Open mold: Please select a start time...', 'OK', {
          duration: 5000,
        });
        return { isValid: false, index: 3 };
      }

      if (openMold.duration === undefined) {
        this.snackBar.open('Open mold: Please select a duration time...', 'OK', { duration: 5000 });
        return { isValid: false, index: 3 };
      }

      if (openMold.moldClosingTimeDuration === undefined) {
        this.snackBar.open('Open mold: Please select a end closing time...', 'OK', { duration: 5000 });
        return { isValid: false, index: 3 };
      }

      if (openMold.moldClosingTime === undefined) {
        this.snackBar.open('Open mold: Please select a mold closing time...', 'OK', { duration: 5000 });
        return { isValid: false, index: 3 };
      }

      if (openMold.nozzleDiameter === undefined) {
        this.snackBar.open('Open mold: Please select a nozzle diameter...', 'OK', { duration: 5000 });
        return { isValid: false, index: 3 };
      }

      if (openMold.nozzleVelocity === undefined) {
        this.snackBar.open('Open mold: Please select a nozzle velocity...', 'OK', { duration: 5000 });
        return { isValid: false, index: 3 };
      }

      if (openMold.offset === undefined) {
        this.snackBar.open('Open mold: Please select a offset...', 'OK', {
          duration: 5000,
        });
        return { isValid: false, index: 3 };
      }

      if (openMold.isClosingSetup && moldClosing.openingVector === undefined) {
        this.snackBar.open('Open mold (mold closing setup): Please select a opening vector...', 'OK', {
          duration: 5000,
        });
        return { isValid: false, index: 3 };
      }

      if (openMold.isClosingSetup && moldClosing.part === undefined) {
        this.snackBar.open('Open mold (mold closing setup): Please select a part...', 'OK', { duration: 5000 });
        return { isValid: false, index: 3 };
      }

      if (path.length >= 2) {
        this.snackBar.open('Open mold: Please add at least two points nozzle points...', 'OK', { duration: 5000 });
        return { isValid: false, index: 3 };
      }
    }

    if (!foaming.mesh) {
      this.snackBar.open('Part: Please select a model...', 'OK', {
        duration: 5000,
      });
      return { isValid: false, index: 0 };
    }

    if (!material) {
      this.snackBar.open('Material: Please select a material...', 'OK', {
        duration: 5000,
      });
      return { isValid: false, index: 1 };
    }

    if (!usimdata) {
      this.snackBar.open('Material: Please select a simulation data...', 'OK', {
        duration: 5000,
      });
      return { isValid: false, index: 1 };
    }

    // if (!foaming.recipe) {
    //   this.snackBar.open('Material: Please select a recipe...', 'OK', {
    //     duration: 5000,
    //   });
    //   return { isValid: false, index: 1 };
    // }

    // if (!foaming.materialTemperature) {
    //   this.snackBar.open('Material: Please select a temperature...', 'OK', {
    //     duration: 5000,
    //   });
    //   return { isValid: false, index: 1 };
    // }

    if (!foaming.injectionRate) {
      if (foaming.injectionRate !== 0) {
        this.snackBar.open('Process data: Please enter a injection rate...', 'OK', { duration: 5000 });
        return { isValid: false, index: 2 };
      }
    }

    if (!foaming.targetDensity) {
      if (foaming.targetDensity !== 0) {
        this.snackBar.open('Process data: Please enter a target density...', 'OK', { duration: 5000 });
        return { isValid: false, index: 2 };
      }
    }

    if (!foaming.title) {
      this.snackBar.open('Simulate: Please enter a simulation name...', 'OK', {
        duration: 5000,
      });
      return { isValid: false, index: 3 };
    }

    if (!foaming.simulationTime) {
      if (foaming.simulationTime !== 0) {
        this.snackBar.open('Simulate: Please enter a simulation time...', 'OK', { duration: 5000 });
        return { isValid: false, index: 3 + stepOrder };
      }
    }

    if (!foaming.nCpus) {
      this.snackBar.open('Simulate: Please select the number of cpus...', 'OK', { duration: 5000 });
      return { isValid: false, index: 3 + stepOrder };
    }

    if (!foaming.outputTime) {
      if (foaming.outputTime !== 0) {
        this.snackBar.open('Simulate: Please enter a output time...', 'OK', {
          duration: 5000,
        });
        return { isValid: false, index: 3 + stepOrder };
      }
    }

    if (Number(foaming.simulationTime) < Number(foaming.outputTime)) {
      this.snackBar.open('Simulation time must be greater than output time...', 'OK', { duration: 5000 });
      return { isValid: false, index: 3 + stepOrder };
    }

    return { isValid: true, index: -1 };
  }
}
